import React from 'react'

function Icon() {
  return (
    <div>
        <svg
      fill="#000000"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(0)matrix(-1, 0, 0, 1, 0, 0)"
       width="22"
      height="22"
      style={{ display: "inline-block" }}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <title>copy</title>
        <path d="M17.875 5.844l3.281 3.406c0.313 0.344 0.594 1.063 0.594 1.531v10.094c0 0.469-0.375 0.906-0.875 0.906h-5.844v-1.531h4.906c0.156 0 0.281-0.125 0.281-0.281v-8.5c0-0.156-0.125-0.281-0.281-0.281h-3.625c-0.156 0-0.313-0.125-0.313-0.281v-3.875c0-0.156-0.125-0.281-0.281-0.281h-5.938c-0.156 0-0.313 0.125-0.313 0.281v2.156c-0.313-0.125-0.719-0.188-1.031-0.188h-0.469v-2.906c0-0.5 0.406-0.875 0.875-0.875h7.563c0.469 0 1.156 0.281 1.469 0.625zM17.813 9.656h1.313c0.156 0 0.188-0.094 0.094-0.219l-1.5-1.531c-0.094-0.125-0.188-0.094-0.188 0.063v1.406c0 0.156 0.125 0.281 0.281 0.281zM9.938 10.844l3.25 3.438c0.344 0.344 0.594 1.031 0.594 1.5v10.094c0 0.5-0.375 0.906-0.844 0.906h-12.031c-0.5 0-0.906-0.406-0.906-0.906v-14.781c0-0.469 0.406-0.906 0.906-0.906h7.531c0.469 0 1.156 0.313 1.5 0.656zM1.813 25.25h10.156c0.156 0 0.313-0.125 0.313-0.281v-8.5c0-0.156-0.156-0.281-0.313-0.281h-3.625c-0.156 0-0.281-0.125-0.281-0.281v-3.875c0-0.156-0.125-0.281-0.281-0.281h-5.969c-0.156 0-0.281 0.125-0.281 0.281v12.938c0 0.156 0.125 0.281 0.281 0.281zM11.25 14.469l-1.469-1.594c-0.125-0.125-0.219-0.031-0.219 0.125v1.375c0 0.156 0.156 0.281 0.313 0.281h1.281c0.156 0 0.219-0.094 0.094-0.188z"></path>
      </g>
    </svg>
    </div>
  )
}

export default Icon
